import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import ServicesPage from "./pages/ServicesPage";
import { ServicesViewMorePage } from "./pages/ServicesViewMorePage";
import CommonRoute from "../auth/components/routes/CommonRoute";
import CategoriesPage from "./pages/CategoriesPage";
import CategoryServiceListPage from "./pages/CategoryServiceListPage";

export function ServicesRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
          ]}
          component={CategoriesPage}
        />
        <AuthRoute
          exact
          path={`${path}/category/:categoryName`}
          roles={[
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
          ]}
          component={CategoryServiceListPage}
        />
        <AuthRoute
          exact
          path={`${path}/management`}
          roles={[UserRole.ServiceProvider]}
          component={ServicesPage}
        />
        <CommonRoute
          exact
          path={`${path}/:id`}
          component={ServicesViewMorePage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
